import React from "react";
import { NOTE_MAX_LENGTH } from "../../Apihander/Note/Note";
import "../../css/app/recorder.css";

// The optional note typed while recording; it is uploaded with the audio.
const RecordingNote = ({ value = "", onChange, disabled }) => {
    const handleChange = (e) => {
        const text = e?.target?.value || "";
        if (text.length > NOTE_MAX_LENGTH) {
            return;
        }
        onChange(text);
    };

    return (
        <div className="vr-recnote">
            <div className="vr-recnote-head">
                <span className="vr-recnote-label">Note </span>
                <span className="vr-recnote-count">
                    {`${value.length}/${NOTE_MAX_LENGTH}`}
                </span>
            </div>
            <textarea
                className="form-control input-field vr-recnote-input"
                rows={3}
                placeholder="Add a note for this recording"
                value={value}
                disabled={disabled}
                onChange={handleChange}
            />
        </div>
    );
};

export default RecordingNote;
